<a [attr.data-cy]="name" class="select-card" (click)="onClick()">
  <img class="image" [src]="imageUrl" [alt]="imageAltText" />
  <div class="name">{{ name }}</div>
</a>
